declare type PathResources = 'Markets' | 'ByOrigin';

export const PathResources: Record<PathResources, PathResources> = {
  Markets: 'Markets',
  ByOrigin: 'ByOrigin'
};
